import { createSlice } from '@reduxjs/toolkit'

export const OLdTargetLanguageSlice = createSlice(
{

  name: 'old_target_language',
  initialState: {
    value: [],
  },
  reducers: {
    updateOldTargetLanguage: (state, action) => {
      state.value = action.payload
    },
  },
}
)

export const { updateOldTargetLanguage } = OLdTargetLanguageSlice.actions

export default OLdTargetLanguageSlice.reducer